import { Note } from '../generated/interfaces';
import { Observable } from 'rxjs';

export abstract class AbstractNoteService {
    abstract create(note: string): Observable<Note>;

    abstract save(note: Note, text: string): Observable<Note>;

    abstract saveAsDraft(note: Note, text: string): Observable<Note>;

    abstract delete(noteId: string): Observable<void>;
}